import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import { c as classNames } from '../../shared/bind-6101ab28.js';
import { deprecationWarning } from '../../utils/warning.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import Loader from '../Loader/Loader.js';

var styles = {
  "unit-base": "4",
  "button": "web_ui__Button__button",
  "inline": "web_ui__Button__inline",
  "disabled": "web_ui__Button__disabled",
  "content": "web_ui__Button__content",
  "label": "web_ui__Button__label",
  "truncated": "web_ui__Button__truncated",
  "icon": "web_ui__Button__icon",
  "loader": "web_ui__Button__loader",
  "with-loader": "web_ui__Button__with-loader",
  "default": "web_ui__Button__default",
  "without-text": "web_ui__Button__without-text",
  "icon-left": "web_ui__Button__icon-left",
  "icon-right": "web_ui__Button__icon-right",
  "medium": "web_ui__Button__medium",
  "small": "web_ui__Button__small",
  "outlined": "web_ui__Button__outlined",
  "filled": "web_ui__Button__filled",
  "flat": "web_ui__Button__flat",
  "inverse": "web_ui__Button__inverse",
  "primary": "web_ui__Button__primary",
  "amplified": "web_ui__Button__amplified",
  "muted": "web_ui__Button__muted",
  "warning": "web_ui__Button__warning",
  "success": "web_ui__Button__success",
  "expose": "web_ui__Button__expose"
};

var _excluded = ["type", "styling", "size", "inline", "theme", "truncated", "disabled", "inverse", "iconPosition", "icon", "iconName", "iconColor", "isLoading", "jsClass", "children", "text", "url", "aria", "forwardedRef", "urlProps", "onClick", "testId"];
var Styling = /*#__PURE__*/function (Styling) {
  Styling["Outlined"] = "outlined";
  Styling["Filled"] = "filled";
  Styling["Flat"] = "flat";
  return Styling;
}({});
var IconPosition = /*#__PURE__*/function (IconPosition) {
  IconPosition["Left"] = "left";
  IconPosition["Right"] = "right";
  return IconPosition;
}(IconPosition || {});
var Type = /*#__PURE__*/function (Type) {
  Type["Button"] = "button";
  Type["Submit"] = "submit";
  Type["Reset"] = "reset";
  return Type;
}(Type || {});
var Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Medium"] = "medium";
  Size["Small"] = "small";
  return Size;
}({});
var cssClasses = classNames.bind(styles);
var Button = function Button(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? Type.Button : _ref$type,
    _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? Styling.Outlined : _ref$styling,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Default : _ref$size,
    inline = _ref.inline,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'primary' : _ref$theme,
    _ref$truncated = _ref.truncated,
    truncated = _ref$truncated === void 0 ? true : _ref$truncated,
    disabled = _ref.disabled,
    inverse = _ref.inverse,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? IconPosition.Left : _ref$iconPosition,
    icon = _ref.icon,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    isLoading = _ref.isLoading,
    jsClass = _ref.jsClass,
    children = _ref.children,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    url = _ref.url,
    aria = _ref.aria,
    forwardedRef = _ref.forwardedRef,
    urlProps = _ref.urlProps,
    onClick = _ref.onClick,
    testId = _ref.testId,
    elementProps = _objectWithoutProperties(_ref, _excluded);
  var renderIcon = function renderIcon() {
    if (icon) {
      return /*#__PURE__*/jsx("span", {
        className: styles.icon,
        children: icon
      });
    }
    if (iconName) {
      return /*#__PURE__*/jsx("span", {
        className: styles.icon,
        children: /*#__PURE__*/jsx(Icon, {
          name: iconName,
          color: iconColor
        })
      });
    }
    return null;
  };
  var renderLoader = function renderLoader() {
    if (!isLoading) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.loader,
      children: /*#__PURE__*/jsx(Loader, {
        size: size,
        theme: styling === 'filled' && !inverse ? null : theme
      })
    });
  };
  var contentText = children || text;
  var buttonClass = cssClasses('button', styling, size, theme, jsClass, _defineProperty(_defineProperty(_defineProperty({
    inline: inline,
    inverse: inverse,
    disabled: disabled,
    truncated: truncated
  }, "icon-".concat(iconPosition), icon || iconName), 'without-text', !contentText), 'with-loader', isLoading));
  var content = /*#__PURE__*/jsxs("span", {
    className: styles.content,
    children: [contentText ? /*#__PURE__*/jsx("span", {
      className: styles.label,
      children: contentText
    }) : null, renderIcon(), renderLoader()]
  });
  if (url) {
    var className = cssClasses(buttonClass, urlProps === null || urlProps === void 0 ? void 0 : urlProps.className);
    return (
      /*#__PURE__*/
      // @ts-expect-error - spreading props that may contain invalid a-tag fields (e.g. ref)
      jsx("a", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        "aria-busy": isLoading || undefined,
        "aria-disabled": disabled || undefined
      }, elementProps), aria), urlProps), {}, {
        href: url,
        className: className,
        "data-testid": testId,
        onClick: onClick,
        children: content
      }))
    );
  }
  return /*#__PURE__*/jsx("button", _objectSpread(_objectSpread(_objectSpread({
    // eslint-disable-next-line react/button-has-type
    type: type,
    "aria-busy": isLoading || undefined
  }, elementProps), aria), {}, {
    className: buttonClass,
    ref: forwardedRef,
    onClick: onClick,
    "data-testid": testId,
    disabled: disabled,
    children: content
  }));
};
// BUG: default exports do not auto-generate storybook ArgsTable
// https://github.com/storybookjs/storybook/issues/9511
// remove export when resolved
var ButtonWithForwardedRef = /*#__PURE__*/forwardRef(function (props, ref) {
  if (props.jsClass) {
    deprecationWarning('Property jsClass on Button component has been deprecated.');
  }
  return /*#__PURE__*/jsx(Button, _objectSpread({
    forwardedRef: ref
  }, props));
});
ButtonWithForwardedRef.displayName = Button.name;
ButtonWithForwardedRef.Styling = Styling;
ButtonWithForwardedRef.Type = Type;
ButtonWithForwardedRef.Size = Size;
ButtonWithForwardedRef.IconPosition = IconPosition;

export { ButtonWithForwardedRef, Size, Styling, ButtonWithForwardedRef as default };
//# sourceMappingURL=Button.js.map
